var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangleFilled = function SvgAlertTriangleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 3a2.73 2.73 0 0 1 2.37 1.379l7.264 12.714.085.158a2.728 2.728 0 0 1-2.263 3.924l-.18.006H4.741v-.001a2.73 2.73 0 0 1-2.37-1.352 2.73 2.73 0 0 1-.006-2.735L9.63 4.379A2.73 2.73 0 0 1 12 3m-.001 12.717a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2zm0-7.634a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1"
  })));
};
export default SvgAlertTriangleFilled;